import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { isNullOrUndefined } from '@app/util/util';

declare const externalFileAirports;

@Injectable({
  providedIn: 'root'
})
export class AirportsService {

  constructor(private http: HttpClient) { }

  public fetchAirports(): Observable<string[]> {
    return of(!isNullOrUndefined(externalFileAirports) ? externalFileAirports : []);
  }
}
